import React from 'react';
import { FaCheckCircle } from "react-icons/fa";
import IconText from './IconText';

const CheckListItem = ({
  title,
  text,
  className = "",
  titleClass = "text-xl font-semibold text-gray-800 mb-2",
  textClass = "text-gray-600 flex items-center",
  iconClass = "text-secondary mr-2 flex-shrink-0",
  iconSize = 18,
  Icon = FaCheckCircle
}) => {
  return (
    <div className={className}>
      {title && <h4 className={titleClass}>{title}</h4>}
      <IconText
        text={text}
        className={textClass}
        iconClass={iconClass}
        iconSize={iconSize}
        Icon={Icon}
      />
    </div>
  );
};

export default CheckListItem;
